// Universal returns B1 — our survey end links (SCRUM-130 GET /r) with the
// client's respondent-id token (clients.id_token: [identifier], [ids], ${ID},
// [%RID%]...). No token: {userid}, as before.

export const DEFAULT_ID_TOKEN = '{userid}';

// The admin host the end links point at (nginx proxies /r to the backend).
export const endLinkBase = (): string => process.env.REACT_APP_DX_BASE_URL || window.location.origin;

export const tokenOrDefault = (token?: string | null): string => {
    const t = (token || '').trim();
    return t || DEFAULT_ID_TOKEN;
};

// [label, path slug, ?status= code]
export const END_LINK_ROWS: ReadonlyArray<readonly [string, string, number]> = [
    ['Complete URL', 'completed', 1],
    ['Over Quota URL', 'overquota', 3],
    ['Terminate URL', 'terminate', 2],
    ['Quality Terminate URL', 'qualityterminate', 4],
];

// The token is pasted as is (the client's platform replaces it); the survey
// id is ours and URL-encoded.
export function endLinkUrl(base: string, slug: string, token?: string | null, surveyId?: string | number | null): string {
    const sid = surveyId != null && surveyId !== '' ? `&surveyid=${encodeURIComponent(String(surveyId))}` : '';
    return `${base}/r/${slug}?uid=${tokenOrDefault(token)}${sid}`;
}

// The single-URL form: one link, the platform fills status=1..4.
export function singleEndLink(base: string, token?: string | null, status: string | number = '<1|2|3|4>', surveyId?: string | number | null): string {
    const sid = surveyId != null && surveyId !== '' ? `&surveyid=${encodeURIComponent(String(surveyId))}` : '';
    return `${base}/r?status=${status}&uid=${tokenOrDefault(token)}${sid}`;
}
